import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=df672be8"
import script from "./productList.vue?vue&type=script&lang=ts"
export * from "./productList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports